export default __webpack_public_path__ + "static/media/res1.d3d811cb.png";